import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { Form } from 'components';
import { FormWrapper } from 'components/Modal/styles';
import ModalForm from 'components/ModalForm/ModalForm';
import { useSelectedProfileStore } from 'stores/selectedProfileStore';

import { useCreateInventory, useUpdateInventory } from 'api/products/hooks';
import validationSchemas from './schemas';

const InventoryForm = ({ type = 'create', initialValues, FormGroup }) => {
  const { t } = useTranslation(['pages', 'app']);
  const selectedRegion = useSelectedProfileStore((state) => state.selectedRegionUid);
  const { mutate: createInventory, isPending: isCreating } = useCreateInventory();
  const { mutate: updateInventory, isPending: isUpdating } = useUpdateInventory();

  return (
    <ModalForm
      initialValues={{
        uid: initialValues?.uid || undefined,
        name: initialValues?.name || '',
      }}
      onSubmit={({ uid, name }) =>
        type === 'update'
          ? updateInventory({ uid, name, region_uid: selectedRegion })
          : createInventory({ name, region_uid: selectedRegion })
      }
      validationSchema={validationSchemas.inventory}
      cancelLabel={t('app:cancel')}
      submitLabel={t(`app:${type}`)}
      pristine
      isLoading={isCreating || isUpdating}
      ignoreClickedState
      isClosePopupOn={false}
    >
      <FormWrapper>
        <FormGroup required label={t('app:name')}>
          <Form.Input type="text" name="name" />
        </FormGroup>
      </FormWrapper>
    </ModalForm>
  );
};

InventoryForm.propTypes = {
  type: PropTypes.oneOf(['create', 'update']),
  initialValues: PropTypes.object,
  FormGroup: PropTypes.func,
};

export default InventoryForm;
